<template>
  <v-chip color="primary" :small="mini">
    <v-avatar left>
      <v-icon :small="mini">mdi-shield-check</v-icon>
    </v-avatar>
    <span :style="{ 'margin-left': mini ? '-5px' : '0px' }">
      Warranty Eligible
    </span>
  </v-chip>
</template>
    
<script>
  export default {
    name: 'EsWarrantyEligibilityChip',
    props: {
      mini: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
    